import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesSearchRequestComponent} from "./sales-search-request.component";
import {LibraryModule} from "../../../../../../library/src/lib/library.module";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {ReactiveFormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesSearchRequestComponent
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    ReactiveFormsModule,
    GeneralModule
  ],
  exports: [
    SalesSearchRequestComponent
  ]
})
export class SalesSearchRequestModule { }
